import { JsonMappable } from '../data/json-mappable.js'
import type { BranchNameType } from '../types.js'
import type { UserIdType } from '../types.js'
import type { ModuleIdType } from '../types.js'
import type { BusinessObjectTypeType } from '../types.js'

import { assignCommonProperties } from '../util/data/assign-common-properties.js'

import { jsonClass, jsonProperty } from '@sumbricht/json-class-serializer'

@jsonClass('Branch')
export class Branch implements JsonMappable {
	@jsonProperty(String)
	get __type(): string {
		return 'Branch'
	}
	set __type(_) {
		/*ignore*/
	}

	@jsonProperty(String) name!: BranchNameType
	@jsonProperty(Boolean) isActive: boolean = true

	constructor(init?: Partial<Branch>) {
		assignCommonProperties(this, init)
	}
}
